import { Inline, breakpoints, Stack, Input, SelectBox } from '@etg/wings';
import type { TripType } from '@eti/schema-types';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { Controller } from 'react-hook-form';
import { tripTypes } from '../../../constants/tripTypesConstants';
import { DEPARTURE_TIME_OF_DAY, RETURN_TIME_OF_DAY, SINGLE_BOUND } from '../constants/formFields';
import { ANY, MORNING, NOON, AFTERNOON } from '../constants/timeOfDay';

const wrapperStyles = css`
  padding-top: 16px;
`;

const selectBoxStyles = css`
  flex: 1;
  min-width: 0;
`;

const inputGroupStyles = css`
  flex: 1;
  position: relative;
  width: 100%;

  @media (min-width: ${breakpoints._768}) {
    width: calc(50% - 24px);
  }
`;

const options = [
  { textKey: 'Air.Search.TimeOfDayAllDay', value: ANY },
  { textKey: 'Air.Search.TimeOfDayMorning', value: MORNING },
  { textKey: 'Air.Search.TimeOfDayMidday', value: NOON },
  { textKey: 'Air.Search.TimeOfDayEvening', value: AFTERNOON },
];

interface ExtendedSearchFormFieldsNewProps {
  selectedTripType?: TripType;
}

const ExtendedSearchFormFieldsNew = ({ selectedTripType }: ExtendedSearchFormFieldsNewProps) => {
  const { t } = useTranslation();
  const selectBoxOptions = options.map((option) => ({
    ...option,
    label: t(option.textKey),
  }));

  return (
    <Stack>
      <Inline
        className={wrapperStyles}
        collapseBelow="768px"
        spacing={{
          [breakpoints._0]: 24,
          [breakpoints._768]: 48,
        }}
      >
        <Input.Group className={inputGroupStyles}>
          <Controller
            name={`${SINGLE_BOUND}.${DEPARTURE_TIME_OF_DAY}`}
            render={({ field }) => (
              <SelectBox
                className={selectBoxStyles}
                data-testid="searchForm-departureTimeOfDay-selectBox"
                label={t('Searchform.DepartureTime.Label')}
                name={`${SINGLE_BOUND}.${DEPARTURE_TIME_OF_DAY}`}
                onBlur={field.onBlur}
                onChange={({ value }) => field.onChange(value)}
                options={selectBoxOptions}
                value={field.value}
              />
            )}
          />
          {selectedTripType === tripTypes.RETURN && (
            <Controller
              name={`${SINGLE_BOUND}.${RETURN_TIME_OF_DAY}`}
              render={({ field }) => (
                <SelectBox
                  className={selectBoxStyles}
                  data-testid="searchForm-returnTimeOfDay-selectBox"
                  label={t('Searchform.ReturnTime.Label')}
                  name={`${SINGLE_BOUND}.${RETURN_TIME_OF_DAY}`}
                  onBlur={field.onBlur}
                  onChange={({ value }) => field.onChange(value)}
                  options={selectBoxOptions}
                  value={field.value}
                />
              )}
            />
          )}
        </Input.Group>
      </Inline>
    </Stack>
  );
};

export default ExtendedSearchFormFieldsNew;
